// Brand name for the current hostname, e.g. 'altrac' for app/stage/localhost.
const DEFAULT_BRAND_HOSTS = ['altrac', 'app', 'localhost', 'dev', 'stage', 'stage2']

const getBrandName = (hostname = window.location.hostname) => {
  const [first] = hostname.split('.')
  return DEFAULT_BRAND_HOSTS.includes(first) ? 'altrac' : first
}

export default getBrandName
